import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LoginResponse, TwoFactorType, User, UserRole } from '@shared/models';

import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private _userInfo$ = new BehaviorSubject<LoginResponse | null>(null);

  get token(): string | null {
    return this._userInfo$ ? this._userInfo$.value?.token?.accessToken : null;
  }

  get refreshToken(): string | null {
    return this._userInfo$ ? this._userInfo$.value?.token?.refreshToken : null;
  }

  get user(): User | undefined {
    return this._userInfo$?.value?.user;
  }

  get user$(): Observable<User | null> {
    return this._userInfo$?.asObservable().pipe(map((x) => x?.user));
  }

  get userTwoFactorType(): TwoFactorType {
    return this._userInfo$?.value?.twoFactorType;
  }

  constructor(private localStorageService: LocalStorageService) {
    this._userInfo$.next(localStorageService.load(LocalStorageService.AUTH_USER_INFO));
  }

  setToken(token: string): void {
    const userInfo = this._userInfo$?.value;
    if (userInfo) {
      userInfo.token.accessToken = token;
      this.localStorageService.store(LocalStorageService.AUTH_USER_INFO, userInfo);
    }
  }

  setUser(response: LoginResponse): void {
    this._userInfo$.next(response);
    if (response) {
      this.localStorageService.store(LocalStorageService.AUTH_USER_INFO, response);
    } else {
      this.localStorageService.remove(LocalStorageService.AUTH_USER_INFO);
    }
  }

  isUserInRole(role: UserRole): boolean {
    return this.user?.roles == role;
  }

  isUserInOneOfRoles(roles: UserRole[]): boolean {
    let result = false;
    roles?.forEach((x) => {
      if (this.isUserInRole(x)) {
        result = true;
      }
    });
    return result;
  }

  isUserLoggedIn(): boolean {
    if (this.user) {
      return true;
    }
    return false;
  }
}
